// extracted by mini-css-extract-plugin
export default {"courseContainer":"courseContainer__tZX0l","courseContent":"courseContent__K6KU5"};